import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Navbar, Footer } from "../../components/Layout";
import { toast, Toaster } from "sonner";
import { ArrowLeft, Search, Trash2, Folder, Upload, Copy } from "lucide-react";

export default function MediaLibrary() {
  const [data, setData] = useState({ items: [], folders: [] });
  const [folder, setFolder] = useState("");
  const [q, setQ] = useState("");
  const [uploading, setUploading] = useState(false);

  const load = async () => {
    const params = new URLSearchParams();
    if (folder) params.set("folder", folder);
    if (q) params.set("q", q);
    const { data } = await api.get(`/admin/media?${params}`);
    setData(data);
  };
  useEffect(() => { load(); }, [folder, q]);

  const upload = async (files) => {
    setUploading(true);
    for (const f of files) {
      const fd = new FormData();
      fd.append("file", f);
      if (folder) fd.append("folder", folder);
      try { await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }); }
      catch { toast.error(`Échec: ${f.name}`); }
    }
    setUploading(false);
    toast.success("Upload terminé");
    load();
  };

  const remove = async (id) => {
    if (!confirm("Supprimer ce média ?")) return;
    await api.delete(`/admin/media/${id}`);
    toast.success("Média supprimé");
    load();
  };

  const copyUrl = (url) => {
    const fullUrl = `${process.env.REACT_APP_BACKEND_URL}${url}`;
    navigator.clipboard.writeText(fullUrl);
    toast.success("URL copiée");
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <Navbar />
      <Toaster richColors position="top-right" />
      <section className="max-w-7xl mx-auto px-6 md:px-8 py-12">
        <Link to="/admin" className="text-xs font-bold uppercase tracking-widest text-slate-500 hover:text-slate-900 mb-6 inline-flex items-center gap-2"><ArrowLeft className="w-3 h-3"/> Retour</Link>
        <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight mb-8">Bibliothèque média</h1>

        <div className="bg-white border border-slate-900/15 p-6 mb-6 flex flex-wrap gap-3 items-center">
          <div className="flex-1 min-w-[200px] flex items-center gap-2 border border-slate-900/20 px-3">
            <Search className="w-4 h-4 text-slate-400"/>
            <input value={q} onChange={e => setQ(e.target.value)} placeholder="Rechercher..." className="w-full py-2 outline-none text-sm" data-testid="media-search" />
          </div>
          <select value={folder} onChange={e => setFolder(e.target.value)} className="input" data-testid="media-folder-select">
            <option value="">Tous les dossiers</option>
            {data.folders.map(f => <option key={f} value={f}>{f}</option>)}
          </select>
          <input value={folder} onChange={e => setFolder(e.target.value)} placeholder="Nouveau dossier..." className="input max-w-[180px]" />
          <label className="btn-brutal btn-brutal-solar px-5 py-2 text-xs font-bold uppercase tracking-wider cursor-pointer flex items-center gap-2" data-testid="media-upload">
            <Upload className="w-3 h-3"/>{uploading ? "Upload..." : "Uploader"}
            <input type="file" accept="image/*" multiple onChange={e => upload(Array.from(e.target.files))} className="hidden" />
          </label>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {data.items.length === 0 && <div className="col-span-full p-16 text-center text-slate-500 font-mono text-sm">Aucun média{q || folder ? " pour ces critères." : "."}</div>}
          {data.items.map(it => (
            <div key={it.id} className="bg-white border border-slate-900/15 group" data-testid={`media-${it.id}`}>
              <div className="aspect-square overflow-hidden bg-slate-100">
                {it.kind === "video" ? (
                  <div className="w-full h-full flex items-center justify-center bg-slate-900 text-white text-xs font-mono">VIDÉO</div>
                ) : (
                  <img src={`${process.env.REACT_APP_BACKEND_URL}${it.url}`} alt={it.original_filename} className="w-full h-full object-cover" />
                )}
              </div>
              <div className="p-2">
                <div className="text-xs font-mono truncate" title={it.original_filename}>{it.original_filename}</div>
                <div className="flex items-center justify-between mt-1 text-xs">
                  <span className="flex items-center gap-1 text-slate-500"><Folder className="w-3 h-3"/>{it.folder || "general"}</span>
                  <div className="flex gap-1">
                    <button onClick={() => copyUrl(it.url)} title="Copier l'URL" className="p-1 border border-slate-300 hover:border-slate-900"><Copy className="w-3 h-3"/></button>
                    <button onClick={() => remove(it.id)} title="Supprimer" className="p-1 border border-slate-300 hover:border-red-600 hover:bg-red-600 hover:text-white"><Trash2 className="w-3 h-3"/></button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
